var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex justify-content-center"},[_c('b-alert',{staticClass:"m-2",attrs:{"variant":"info","show":""}},[_vm._v("\n    "+_vm._s(_vm.placeholderText)+"\n  ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }